import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5c4c0950"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ba-weekly ba-column-title ba-column-relative ba-text ba-text-right",
  style: {
    "padding": "0 2px"
  }
};
const _hoisted_2 = {
  key: 0,
  style: {
    "width": "100%"
  }
};
const _hoisted_3 = {
  class: "ba-text weekly-ai"
};
const _hoisted_4 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_5 = {
  class: "ba-double-content"
};
const _hoisted_6 = {
  style: {
    "display": "flex",
    "width": "100%",
    "justify-content": "space-between",
    "padding": "0 4px"
  }
};
const _hoisted_7 = ["id"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "popover-text",
  style: {
    "max-width": "200px",
    "text-align": "left"
  }
}, " Last budget before pausing the campaign. ", -1));
const _hoisted_9 = {
  key: 1,
  style: {
    "width": "100%"
  }
};
const _hoisted_10 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_11 = {
  class: "ba-double-content"
};
const _hoisted_12 = {
  style: {
    "display": "flex",
    "width": "100%",
    "justify-content": "space-between",
    "padding": "0 4px"
  }
};
const _hoisted_13 = ["id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_clock_rewind_icon = _resolveComponent("clock-rewind-icon");
  const _component_app_popover = _resolveComponent("app-popover");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.loading ? (_openBlock(), _createBlock(_component_b_spinner, {
    key: 0,
    small: ""
  })) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$props.is_paused ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_app_icon, {
    icon: "ai",
    size: 14,
    color: "#5A52AE"
  }), _createVNode(_component_currency_value, {
    value: 0,
    currency: $props.currency,
    precision: $props.currency_precision,
    allowPrecisionModification: false
  }, null, 8, ["currency", "precision"])]), _createElementVNode("div", {
    class: "ba-double-content-inner",
    id: `last_budget_${$props.item_id}`
  }, [_createVNode(_component_clock_rewind_icon, {
    width: 12,
    height: 12,
    color: "#93999F"
  }), _createVNode(_component_currency_value, {
    value: $props.value,
    currency: $props.currency,
    precision: $props.currency_precision,
    allowPrecisionModification: false
  }, null, 8, ["value", "currency", "precision"]), $props.is_paused ? (_openBlock(), _createBlock(_component_app_popover, {
    key: 0,
    target: `last_budget_${$props.item_id}`,
    "auto-width": "",
    placement: "left"
  }, {
    default: _withCtx(() => [_hoisted_8]),
    _: 1
  }, 8, ["target"])) : _createCommentVNode("", true)], 8, _hoisted_7)])])])])) : _createCommentVNode("", true), !$props.is_paused && $options.aiValue && $props.value !== $props.ai_value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", {
    class: "ba-text weekly-ai",
    onClick: _cache[2] || (_cache[2] = () => {
      _ctx.$emit('budget-change');
    }),
    style: {
      "cursor": "pointer"
    }
  }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_app_icon, {
    icon: "gear",
    size: 14,
    class: "weekly-settings"
  }), _createVNode(_component_app_icon, {
    icon: "reset",
    size: 14,
    color: "#4C8EFF",
    class: "weekly-reset",
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {
      _ctx.$emit('reset');
    }, ["stop"]))
  }), _createVNode(_component_currency_value, {
    value: $props.value,
    currency: $props.currency,
    precision: $props.currency_precision,
    allowPrecisionModification: false,
    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {
      _ctx.$emit('budget-change');
    }, ["stop"]))
  }, null, 8, ["value", "currency", "precision"])]), _createElementVNode("div", {
    class: "ba-double-content-inner",
    id: `last_budget_${$props.item_id}`
  }, [_createVNode(_component_app_icon, {
    icon: "ai",
    size: 12,
    color: "#A8A0FF"
  }), _createVNode(_component_currency_value, {
    value: $props.ai_value,
    currency: $props.currency,
    precision: $props.currency_precision,
    allowPrecisionModification: false
  }, null, 8, ["value", "currency", "precision"])], 8, _hoisted_13)])])])])) : _createCommentVNode("", true), !$props.is_paused && (!$options.aiValue || $props.value === $props.ai_value) ? (_openBlock(), _createBlock(_component_currency_value, {
    key: 2,
    value: $props.value,
    currency: $props.currency,
    precision: $props.currency_precision,
    allowPrecisionModification: false,
    class: "budget-text ba-text ba-text-right",
    onClick: _cache[3] || (_cache[3] = () => {
      _ctx.$emit('budget-change');
    }),
    style: {
      "cursor": "pointer"
    }
  }, null, 8, ["value", "currency", "precision"])) : _createCommentVNode("", true)], 64))]);
}